<script>
  let getDate = new Date();
</script>

<div class="footer">
  <footer>
    &#169; Copywrite {getDate.getFullYear()} - Built in Svelte - Quotes via Quotable.io
  </footer>
</div>

<style lang="scss">
  .footer {
    display: flex;
    width: 90vw;
    height: 10vh;
    align-items: center;
    justify-content: center;
    footer {
      opacity: 0.5;
    }
  }
</style>
